import {z} from 'zod'
import {validateBban, validateBic, validateIban} from '@/bank/bank-account.service'
import {emptyStringToNull} from '@/validation-utils/ZodHelpers'

export const SupplierBankSchema = z.object({
    bban: emptyStringToNull(z.string().refine(validateBban, 'Ugyldig bankkontonummer. Forventet format eks: 12345678903')),
    bic: emptyStringToNull(z.string().refine(validateBic, 'Ugyldig BIC-format. Forventet 8 eller 11-karakter kode. Eks: NWBKGB2L, BOFAGB22XXX')),
    iban: emptyStringToNull(z.string().refine(validateIban, 'Ugyldig IBAN-format. Forventet format eks: DE89370400440532013000'))
})

